import AssetType from '../../../../components/AssetType';
import Card from '../../../../components/Card';
import { TradePair } from '../../../../context/chart/chartTypes';
import { formatPercentages, formatUSD } from '../../../../helpers';
import { UserOrder } from '../../../../hooks/web3/trade/useUserOpenOrders';
import { UserPositionRaw } from '../../../../hooks/web3/trade/useUserPositions';
import MarkPrice from '../../../../pages/Trade/ExchangeLists/MarkPrice';

type PositionDetailsProps = {
    userPosition: UserPositionRaw | UserOrder | undefined;
    selectedTradePair: TradePair | undefined;
};

const PositionDetails: React.FC<PositionDetailsProps> = ({
    userPosition,
    selectedTradePair,
}) => {
    return (
        <Card variant='secondary' className='position-details'>
            <div className='position-type'>
                <AssetType
                    tradePair={selectedTradePair}
                    isShort={userPosition?.isShort ?? false}
                    leverage={formatPercentages(userPosition?.leverage || 0, 2)}
                />
            </div>
            <div className='position-details__inner'>
                <div className='entry-price'>
                    <div className='title'>
                        Entry Price
                        <span>:&nbsp;</span>
                    </div>
                    <div className='value'>
                        {formatUSD(userPosition?.entryPrice || 0, {
                            minDecimals: 2,
                            maxDecimals: selectedTradePair?.decimalFormatting,
                        })}
                    </div>
                </div>
                <div className='mark-price'>
                    <div>
                        <div className='title'>
                            Mark Price
                            <span>:&nbsp;</span>
                        </div>
                        <div className='value'>
                            <MarkPrice pool={selectedTradePair} />
                        </div>
                    </div>
                </div>
                <div className='liquidation-price'>
                    <div className='title'>
                        Liq. Price
                        <span>:&nbsp;</span>
                    </div>
                    <div className='value'>
                        {formatUSD(userPosition?.bankruptcyPrice || 0, {
                            minDecimals: 2,
                            maxDecimals: selectedTradePair?.decimalFormatting,
                        })}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default PositionDetails;
